import styled from '@emotion/styled';
import { Tabs } from 'antd';
import { useState } from 'react';
import { BondEntity } from '../../../../entities/bond.entity';
import { PRIMARY } from '../../../../shared/colors';
import { Orders } from './components/orders';
import { Transactions } from './components/transactions';

const Container = styled.div`
  height: 100%;

  > .content {
    // padding: 5px;
    font-family: Poppins-R;
    border-radius: 5px;
  }
`;

export const Activity = ({
  orders,
  transactions,
  getSelectedBond,
  updateOders,
}: {
  orders: any[];
  transactions: any[];
  getSelectedBond: (bond: BondEntity) => void;
  updateOders: () => void;
}) => {
  const [tabIndex, setTabIndex] = useState('1');
  return (
    <Container>
      <div className='content'>
        <Tabs
          defaultActiveKey='1'
          activeKey={tabIndex}
          type='line'
          onChange={(key: string) => setTabIndex(key)}
          size='small'
          tabBarStyle={{
            backgroundColor: PRIMARY,
            color: 'white',
            margin: 0,
            borderRadius: 7,
          }}
        >
          <Tabs.TabPane
            tab={
              <span style={{ color: 'orange', marginLeft: 10 }}>ACTIVITE</span>
            }
            key='0'
            disabled
          >
            <p>ACTIVITE</p>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Ordres' key='1'>
            <Orders
              orders={orders}
              updateOders={updateOders}
              getSelectedBond={getSelectedBond}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Transactions' key='2'>
            <Transactions transactions={transactions} />
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab='Récapitulatif' key='3'>
            <Summary orders={orders} transactions={transactions} />
          </Tabs.TabPane> */}
        </Tabs>
      </div>
    </Container>
  );
};
